import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'components/i18n';
import api from 'libs/api';
import { queryCache } from 'react-query';
import { useFormModal } from 'components/modal-dialog';
import { Account } from './GeneralLedgerPage';
import AccountForm from './AccountForm';


type AccountModalOptions = {
  isNew?: boolean;
  account: Account;
  onSubmit?: (account: Account) => any;
}

const useAccountModal = () => {

  const [showModal, hideModal] = useFormModal();
  const intl = useIntl();

  const showAccountModal = useCallback((options: AccountModalOptions) => {
    const {account, onSubmit} = options;
    showModal({
      id: 'accountsModal',
      title: account.isNew? <FormattedMessage id="sale.AccountModal.title.create" defaultMessage="New account"/> : <FormattedMessage id="sale.AccountModal.title.edit" defaultMessage="Edit account"/>,
      initialValues: account,
      onSubmit: async (newValues: Account) => {
        let updatedItem;
        if(newValues.isNew) {
          // eslint-disable-next-line no-param-reassign
          newValues.isNew = undefined;
          updatedItem = await api.post('/accounts', newValues) as Account;
        }else {
          updatedItem = await api.patch('/accounts', newValues) as Account;
        }
        queryCache.invalidateQueries('accounts');
        if(onSubmit) onSubmit(updatedItem);
      },
      form: AccountForm,
      submitText: account.isNew? intl.formatMessage({id:"sale.AccountModal.submitText.create",defaultMessage:"Create new account"}) : intl.formatMessage({id:"sale.AccountModal.submitText.edit",defaultMessage:"Save account"}),
      width: 'medium',
    });
  },
    [showModal]);

  return showAccountModal;
};

export default useAccountModal;
